import { expand } from 'uri-template-lite';
import { apiClient } from '../../../../common/ApiClient';
import { createApiQueryHook } from '../../../../common/queryClient/createApiQueryHook';
import { UserFollowedDataSubjectQueryDtoType } from '../schema/types';
import { UserFollowedDataSubjectUrl } from './UserFollowedDataSubjectUrl';
import { Page, PageRequestParams } from '../../../../common/queryClient';

export const DASHBOARD_GROUP_TABLE_PAGE_SIZE = 11;

export interface UserFollowedDataSubjectFilter {
  dataSubject?: string;
}

export type UserFollowedDataSubjectParams = UserFollowedDataSubjectFilter &
  PageRequestParams<keyof UserFollowedDataSubjectFilter>;

const getUserFollowedDataSubjects = (params: UserFollowedDataSubjectParams) =>
  apiClient
    .get<Page<UserFollowedDataSubjectQueryDtoType>>(
      expand(UserFollowedDataSubjectUrl.base, {
        ...params,
        size: DASHBOARD_GROUP_TABLE_PAGE_SIZE,
      }),
    )
    .then((response) => response.data);

export const useListUserFollowedDataSubjectQuery = createApiQueryHook(
  ['user-followed-data-subjects'],
  getUserFollowedDataSubjects,
);
